/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_MemberInputs */

const en_mk_sec_pg_role_member = /** @type {(inputs: Mk_Sec_Pg_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

const id_mk_sec_pg_role_member = /** @type {(inputs: Mk_Sec_Pg_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota`)
};

/**
* | output |
* | --- |
* | "Member" |
*
* @param {Mk_Sec_Pg_Role_MemberInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_member = /** @type {((inputs?: Mk_Sec_Pg_Role_MemberInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_MemberInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_member(inputs)
	return en_mk_sec_pg_role_member(inputs)
});